import { EnsaioAliquotaLogResultados } from '@models/ensaio-aliquota-log-resultados.model';
import { DesfazResultadoDto } from '@/../../back/src/ensaio-aliquota-log-resultados/dto/desfaz-resultado.dto';
import axios from 'axios';

const desfazResultado = async (
  ensaioAliquotaLogResultadoId: number,
  formData: DesfazResultadoDto,
): Promise<EnsaioAliquotaLogResultados> => {
  const res = await axios.patch<EnsaioAliquotaLogResultados>(
    `/log_resultados/${ensaioAliquotaLogResultadoId}/desfazer_resultado`,
    formData,
  );
  return res.data;
};
export default {
  desfazResultado,
};
